import { pickBy } from './helpers';

const searchParamsToObject = (searchParams) => {
  const obj = {};
  Array.from(searchParams.entries()).forEach(([key, value]) => {
    obj[key] = value;
  });
  return obj;
};

const RouteUtils = {
  getQueryParams(location) {
    const searchParams = new URLSearchParams(location.search);
    return searchParamsToObject(searchParams);
  },

  updateQueryParam(history, location, newParams, pathname) {
    const currentParams = RouteUtils.getQueryParams(location);

    let params = { ...currentParams, ...newParams };
    params = pickBy(params);

    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      searchParams.set(key, value);
    });

    history.push({
      pathname: pathname || history.location.pathname,
      search: searchParams.toString()
    });
  },
};

export default RouteUtils;
